var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25665 4.25713V23.7438C4.25665 24.3898 4.51328 25.0094 4.97009 25.4662C5.4269 25.923 6.04647 26.1797 6.69249 26.1797H21.3075C21.9535 26.1797 22.5731 25.923 23.0299 25.4662C23.4867 25.0094 23.7433 24.3898 23.7433 23.7438V9.54533C23.7433 9.22082 23.6784 8.8996 23.5525 8.60052C23.4266 8.30144 23.2422 8.03053 23.0102 7.8037L17.6026 2.5155C17.1475 2.07055 16.5364 1.82137 15.9 1.82129H6.69249C6.04647 1.82129 5.4269 2.07792 4.97009 2.53473C4.51328 2.99154 4.25665 3.6111 4.25665 4.25713ZM9.36966 11.6545H18.1309V13.7362H9.36966V11.6545ZM14.7912 17.076H9.36966V19.1578H14.7912V17.076Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsIcon);
export default __webpack_public_path__ + "static/media/docs-icon.0bad7bf63743325ef27d2c20201b35eb.svg";
export { ForwardRef as ReactComponent };